import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, TextArea, Tile, ToggleSmall } from 'carbon-components-react';
import GenericTabs from '../../../components/common/GenericTabs';
import JDProcessOverlay from '../../../components/common/JDProcessOverlay';
import SuccErrNotification from '../../../components/private/SuccErrNotification';
import {
  getAsessmentCandidateInfo,
  updateAsessmentCandidate,
  updateCandAssessLinkSatus,
  getJSCReportInsightsByCandId,
  updatetCandJSCReport,
  generateJSCReport,
} from '../../../actions/Assessments';
import AssessAddCandidate from './AssessAddCandidate';
import '../CandidateInfo.css';
import { getCurrEnvironment } from '../../common/common';

const orderedScoreDetailKeys = [
  'Dutifulness',
  'Civility',
  'Open-mindedness',
  'Self-regulation',
];

const ColoredCircle = (score) => {
  let finalColor = 'lightgrey';
  if (score) {
    let numericScore = Number(score);
    if (numericScore >= 1 && numericScore <= 3) {
      finalColor = '#fa9196'; // Low
    } else if (numericScore >= 4 && numericScore <= 6) {
      finalColor = '#EFB132'; // Moderate
    } else if (numericScore >= 7 && numericScore <= 10) {
      finalColor = '#7BF39C'; // High
    } else {
      finalColor = 'gray'; // Out of valid range
    }
  }

  return (
    <span
      className="text-center bold ml-1"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: finalColor,
        borderRadius: '50%',
        width: '20px',
        height: '20px',
        border: `2px solid ${finalColor}`,
        fontWeight: 'bold',
      }}>
      <span>{score ?? 'NA*'}</span>
    </span>
  );
};

class AssessCandidateInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'assess-links',
      selectedTestResult: 0,
      scoreDetail: {},
    };
    this.handleRedirect = React.createRef();
  }

  componentDidMount() {
    this.handleGetCandidateInfo();
  }

  handleGetCandidateInfo = () => {
    const { match } = this.props;
    const { params } = match || {};
    const { candId, publicUuid } = params || {};

    this.props.getAsessmentCandidateInfo({ candidateId: candId, publicUuid });
  };

  handleGetJSCInsights = () => {
    const { match } = this.props;
    const { params } = match || {};
    const { candId } = params || {};

    this.props
      .getJSCReportInsightsByCandId(candId)
      .then((res) => {
        if (res && !res.error) {
          const {
            pacereportId,
            scoreDetail,
            summary,
            modifiedSummary,
            message,
          } = res || {};

          if (pacereportId) {
            const reorderedScoreDetail = orderedScoreDetailKeys.reduce(
              (acc, key) => {
                if (scoreDetail[key]) {
                  acc[key] = scoreDetail[key];
                }
                return acc;
              },
              {}
            );
            this.setState({
              pacereportId,
              scoreDetail: reorderedScoreDetail,
              summary,
              modifiedSummary,
              modifiedSummaryOrg: modifiedSummary ?? summary,
            });
          }
          this.setState({ message });
        }
      })
      .catch((e) => {
        this.setState({
          errorNotif: true,
          errMsg:
            'An error has ocurred while processing your request. Please try again later.',
        });
      });
  };

  handleTabClick = (status) => {
    this.setState(
      {
        status,
      },
      () => {
        if (this.state.status === 'jsc-report') this.handleGetJSCInsights();
      }
    );
  };

  handleTestResultTabClick = (tab) => {
    this.setState({ selectedTestResult: tab });
  };

  activeEditCandInfo = () => {
    this.setState({ isOpenEditCandInfoModal: true });
  };

  dismissEditCandModal = () => {
    this.setState({ isOpenEditCandInfoModal: false });
  };

  handleUpdateCandInfo = (data) => {
    const { match } = this.props;
    const { params } = match || {};
    const { candId } = params || {};
    this.setState({ isSubmitting: true }, () => {
      this.props
        .updateAsessmentCandidate([data])
        .then((res) => {
          const { isSuccess, error } = (res && res[candId]) || {};
          const { message } = error || {};
          this.dismissEditCandModal();
          if (isSuccess) {
            this.setState(
              {
                successNotif: true,
                notifMsg: 'Candidate Info has been updated successfully',
                isSubmitting: false,
              },
              () => {
                this.handleGetCandidateInfo();
                setTimeout(() => {
                  this.setState({
                    notifMsg: '',
                    successNotif: false,
                  });
                }, 5000);
              }
            );
          } else {
            this.setState({
              errorNotif: true,
              errMsg: message,
              isSubmitting: false,
            });
          }
        })
        .catch((e) => {
          this.props.dismissAddCandModal();
          this.setState({
            errorNotif: true,
            isSubmitting: false,
          });
        });
    });
  };

  handleToggleClick = (e, assessName, testName, publicUuid) => {
    this.setState({ [`${assessName}-${testName}`]: e }, () => {
      const data = { publicUuid: publicUuid, [`${testName}`]: e };
      this.props.updateCandAssessLinkSatus([data]);
    });
  };

  handleEditAccess = (insightKey, val) => {
    const { modifiedSummary = {}, modifiedSummaryOrg = {} } = this.state;
    const updateState = {
      [`${insightKey}-editable`]: val,
    };
    if (!val) {
      updateState.modifiedSummary = {
        ...modifiedSummary,
        [`${insightKey}`]: modifiedSummaryOrg?.[`${insightKey}`],
      };
    }
    this.setState({ ...updateState });
  };

  handleChange = (e, insightType, insightKey) => {
    const { modifiedSummary } = this.state;
    let updateState = {};
    if (insightType === 'modifiedSummary') {
      updateState.modifiedSummary = {
        ...modifiedSummary,
        [`${insightKey}`]: e.target.value,
      };
    } else updateState = { [e.target.name]: e.target.value };
    this.setState({
      ...updateState,
    });
  };

  handleSave = (insightKey) => {
    const {
      pacereportId,
      modifiedSummary = {},
      modifiedSummaryOrg = {},
    } = this.state;

    const currModifiedTxt = modifiedSummary?.[`${insightKey}`];
    if (
      !currModifiedTxt ||
      (currModifiedTxt && currModifiedTxt.toString().length <= 0)
    ) {
      setTimeout(() => {
        this.setState({
          errorNotif: true,
          errMsg: 'Please enter valid input',
        });
      }, 5000);

      return;
    }

    const data = {
      pacereportId,
      modifiedSummary: {
        ...modifiedSummaryOrg,
        [`${insightKey}`]: modifiedSummary?.[`${insightKey}`],
      },
    };

    this.props
      .updatetCandJSCReport(data)
      .then((res) => {
        const { error } = res || {};
        if (res && !error) {
          this.setState(
            {
              [`${insightKey}-editable`]: false,
              successNotif: true,
              notifMsg: 'Your details have been updated successfully',
            },
            () => {
              this.handleGetJSCInsights();
              setTimeout(() => {
                this.setState({
                  notifMsg: '',
                  successNotif: false,
                });
              }, 5000);
            }
          );
        } else {
          this.setState({
            errorNotif: true,
            errMsg:
              error?.message ||
              'An error has ocurred while processing your request. Please try again later.',
          });
        }
      })
      .catch((e) => {
        this.setState({
          errorNotif: true,
        });
      });
  };

  handleGenReport = () => {
    const { pacereportId } = this.state;
    this.setState({ isExporting: true }, () => {
      this.props
        .generateJSCReport({ pacereportId })
        .then((res) => {
          const { error } = res || {};
          if (res && !res.error) {
            const { fileUrl } = res || {};
            if (fileUrl) {
              window.open(fileUrl);
              this.setState({ isExporting: false });
            }
          } else {
            this.setState({
              isExporting: false,
              errorNotif: true,
              errMsg:
                error?.message ||
                'An error has ocurred while processing your request. Please try again later.',
            });
          }
        })
        .catch((error) => {
          console.error('error', error);
          this.setState({
            isExporting: false,
            errorNotif: true,
          });
        });
    });
  };

  render() {
    const {
      selectedTestResult,
      isOpenEditCandInfoModal,
      successNotif,
      errorNotif,
      notifMsg,
      errMsg,
      isSubmitting,
      scoreDetail = {},
      summary = {},
      modifiedSummary = {},
      isExporting,
      status,
    } = this.state;
    const { assessCandInfo } = this.props;
    const {
      firstName,
      lastName,
      fullName = '',
      nric,
      Company,
      assessmentInfo = [],
    } = assessCandInfo || {};
    const { displayName: schoolName } = Company || {};
    const tabContent = [];
    tabContent.push(
      {
        tabSelected: 'assess-links',
        label: 'Assessment Links',
        value: '',
        onClick: () => this.handleTabClick('assess-links'),
      },

      {
        tabSelected: 'assess-status',
        label: 'Assessment Status',
        value: '',
        onClick: () => this.handleTabClick('assess-status'),
      },
      // {
      //   label: 'Assessment Results',
      //   value: '',
      //   onClick: () => {
      //     this.handleTabClick('assess-results');
      //   },
      // },
      // {
      //   label: 'Assessment Feedback',
      //   value: '',
      //   onClick: () => {
      //     this.handleTabClick('assess-feedback');
      //   },
      // }
      {
        tabSelected: 'jsc-report',
        label: 'JSC Report',
        value: '',
        onClick: () => this.handleTabClick('jsc-report'),
      }
    );

    const selectedTab = tabContent?.findIndex(
      (itm) => itm?.tabSelected == status
    );

    const currEnv = getCurrEnvironment();

    return (
      <div>
        <div
          className={`mt-2 ${
            currEnv === 'local'
              ? 'csc-cand-card-fixed-local'
              : 'csc-cand-card-fixed'
          }`}>
          <Tile>
            <div>
              <div className="d-flex justify-content-between">
                <div className="">
                  <div
                    className="h5 font-weight-bold text-capitalize"
                    style={{ fontSize: '24px' }}>
                    {fullName}{' '}
                    <span className="text-uppercase">
                      {nric ? `(${nric})` : null}
                    </span>
                  </div>
                  <div className="d-flex ml-0 mb-2">
                    {schoolName && (
                      <div className="css-default-text-color f-w-b">
                        {schoolName}
                      </div>
                    )}
                  </div>
                </div>
                <div className="">
                  <div>
                    <Button
                      onClick={() => this.activeEditCandInfo()}
                      kind="tertiary"
                      size="small">
                      Edit
                    </Button>
                  </div>
                  {isOpenEditCandInfoModal && (
                    <AssessAddCandidate
                      dismissAddCandModal={this.dismissEditCandModal}
                      handleUpdateCandInfo={this.handleUpdateCandInfo}
                      isSubmitting={isSubmitting}
                    />
                  )}
                </div>
              </div>
            </div>
          </Tile>
        </div>
        <div className="assess-cand-card-margin-top">
          <input
            style={{ height: 0, opacity: 0 }}
            type="text"
            ref={this.handleRedirect}
          />
          <SuccErrNotification
            successNotif={successNotif}
            errorNotif={errorNotif}
            notifMsg={notifMsg}
            errMsg={errMsg}
            handleCloseNotifBtn={this.handleCloseNotifBtn}
          />
        </div>

        <Tile className="mt-2 css-vertical-min-h">
          <div className="bx--row">
            <div className="bx--col-lg-2 bx--col-md-2 cand-info-tabs">
              <GenericTabs
                className="xpa-cand-info--tabs xpa-c-tabs--vertical m-0"
                selected={selectedTab <= -1 ? 0 : selectedTab}
                tabContent={tabContent}
              />
            </div>
            <div className="bx--col-lg-10 bx--col-md-6 pr-1 pl-0">
              {status === 'assess-links' && (
                <div className="">
                  <div
                    style={{ fontSize: 13 }}
                    className="bx--row m-0 text-uppercase  text-secondary font-weight-bold">
                    <div className="bx--col-lg-3 bx--col-md-2 bx--col-sm-12 bx--col-xs-12 d-lg-block d-md-block d-none">
                      Assessment
                    </div>
                    <div className="bx--col-lg-5 bx--col-md-2 bx--col-sm-12 bx--col-xs-12 d-lg-block d-md-block d-none">
                      Link
                    </div>
                    {/* <div className="bx--col-lg-4 bx--col-md-2 bx--col-sm-12 bx--col-xs-12 d-lg-block d-md-block d-none">
                      Action
                    </div> */}
                  </div>
                  <hr className="mb-2 mt-2" />
                  {assessmentInfo.map((res) => {
                    const { Scenariotestmap, assessmentLink } = res || {};
                    const { Test } = Scenariotestmap || {};
                    const { displayName = '' } = Test || {};
                    return (
                      <Fragment>
                        <div className=" bx--row align-items-center m-0">
                          <div className="font-weight-bold d-flex align-items-center text-capitalize bx--col-lg-3 bx--col-md-2 bx--col-sm-12 bx--col-xs-12">
                            {displayName}
                          </div>
                          <div
                            title={assessmentLink}
                            className=" ml-0 bx--col-lg-9 bx--col-md-2 bx--col-sm-12 bx--col-xs-12 xpa-link">
                            {assessmentLink ?? '-'}
                          </div>
                          {/* <div className=" text-dark ml-0 bx--col-lg-4 bx--col-md-2 bx--col-sm-12 bx--col-xs-12 text-capitalize">
                            <div className="d-flex">
                              <div className="">
                                <Button size="small" onClick={() => {}}>
                                  Copy
                                </Button>
                              </div>
                              <div className="ml-3">
                                <Button size="small" onClick={() => {}}>
                                  Send Link via Email
                                </Button>
                              </div>
                            </div>
                          </div> */}
                        </div>
                        <hr className="mb-2 mt-2" />
                      </Fragment>
                    );
                  })}
                </div>
              )}
              {status === 'assess-status' && (
                <div className="">
                  <div
                    style={{ fontSize: 13 }}
                    className="bx--row m-0 text-uppercase  text-secondary font-weight-bold">
                    <div className="bx--col-lg-3 bx--col-md-2 bx--col-sm-12 bx--col-xs-12 d-lg-block d-md-block d-none">
                      Assessment
                    </div>
                    <div className="bx--col-lg-5 bx--col-md-2 bx--col-sm-12 bx--col-xs-12 d-lg-block d-md-block d-none">
                      Status
                    </div>
                    <div className="bx--col-lg-4 bx--col-md-2 bx--col-sm-12 bx--col-xs-12 d-lg-block d-md-block d-none">
                      Action
                    </div>
                  </div>
                  <hr className="mb-2 mt-2" />
                  {assessmentInfo &&
                    Array.isArray(assessmentInfo) &&
                    assessmentInfo.length > 0 &&
                    assessmentInfo.map((res) => {
                      const {
                        Scenariotestmap,
                        publicUuid,
                        markAsExpired,
                        assessmentStatus,
                      } = res || {};
                      const { Test } = Scenariotestmap || {};
                      const { displayName = '' } = Test || {};
                      return (
                        <Fragment>
                          <div className=" bx--row  m-0">
                            <div className="font-weight-bold d-flex align-items-center text-capitalize bx--col-lg-3 bx--col-md-2 bx--col-sm-12 bx--col-xs-12">
                              {displayName}
                            </div>
                            <div className=" ml-0 bx--col-lg-5 bx--col-md-2 bx--col-sm-12 bx--col-xs-12 xpa-name-overflow">
                              {assessmentStatus}
                            </div>
                            <div className=" text-dark ml-0 bx--col-lg-4 bx--col-md-2 bx--col-sm-12 bx--col-xs-12 text-capitalize">
                              <div
                                className=""
                                style={{
                                  marginTop: '-1rem',
                                }}>
                                <ToggleSmall
                                  id={`${displayName}-markAsExpired`}
                                  name={`${displayName}-markAsExpired`}
                                  className=""
                                  labelText=""
                                  labelA="Active"
                                  labelB="Expired"
                                  toggled={
                                    this.state[
                                      `${displayName}-markAsExpired`
                                    ] ?? markAsExpired
                                  }
                                  onToggle={(e) =>
                                    this.handleToggleClick(
                                      e,
                                      displayName,
                                      'markAsExpired',
                                      publicUuid
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <hr className="mb-2 mt-2" />
                        </Fragment>
                      );
                    })}
                </div>
              )}
              {status === 'assess-results' && (
                <div className="">
                  <GenericTabs
                    className="xpa-psc-appr-w"
                    selected={selectedTestResult}
                    tabContent={[
                      {
                        label: 'ucognify',
                        value: '',
                        onClick: () => {
                          this.handleTestResultTabClick(0);
                        },
                      },
                      {
                        label: 'Neo Profile',
                        value: '',
                        onClick: () => {
                          this.handleTestResultTabClick(1);
                        },
                      },
                    ]}
                  />
                  <div className="mt-2">
                    {selectedTestResult === 0 && (
                      <div className="h6">uCognify Test Result : 61</div>
                    )}
                  </div>
                </div>
              )}
              {status === 'jsc-report' && (
                <div className="">
                  {Object.entries(scoreDetail).length > 0 && (
                    <div className="d-flex justify-content-end mb-3">
                      <Button
                        id="generate-report"
                        size="small"
                        className=""
                        kind="primary"
                        disabled={isExporting}
                        onClick={() => this.handleGenReport()}>
                        {isExporting ? 'Generating' : 'Generate Report'}
                      </Button>
                    </div>
                  )}
                  <div className="mb-2 bx--tile ">
                    {Object.entries(scoreDetail).length > 0 ? (
                      <>
                        {Object.entries(scoreDetail).map(
                          ([insightKey, value]) => {
                            return (
                              <>
                                <div className="mt-2 mb-3 bx--col-lg-12 bx--col-md-12 ">
                                  <div className="bx--row mt-1 mb-1">
                                    <div className="bx--col-lg-12 bx--col-md-12 bx--col-sm-12 bx--col-xs-12 d-flex justify-content-between">
                                      <div className="d-flex align-items-center">
                                        <div className="h6 mb-0 d-inline-block f-w-b">
                                          {insightKey} :
                                        </div>
                                        <div className="ml-3 d-flex align-items-center">
                                          <div className="f-w-b d-flex align-items-center">
                                            Sten Score:{' '}
                                            {ColoredCircle(
                                              scoreDetail?.[insightKey]?.sten
                                            )}
                                          </div>
                                          <div className="mx-2 f-w-b">|</div>
                                          <div className="f-w-b">
                                            T Score:{' '}
                                            {scoreDetail?.[insightKey]
                                              ?.t_score ?? '-'}
                                          </div>

                                          {scoreDetail?.[
                                            insightKey
                                          ]?.facetScores?.flatMap(
                                            (facetObj, idx, arr) => {
                                              const [facetKey, facetVal] =
                                                Object.entries(facetObj)[0];
                                              const facetElement = (
                                                <div
                                                  key={`${facetKey}-${idx}`}
                                                  className="f-w-b d-flex align-items-center">
                                                  <span>
                                                    {facetKey}: {facetVal}
                                                  </span>
                                                </div>
                                              );
                                              return [
                                                <div
                                                  key={`sep-${idx}`}
                                                  className="mx-2 f-w-b">
                                                  |
                                                </div>,
                                                facetElement,
                                              ];
                                            }
                                          )}
                                        </div>
                                      </div>

                                      {summary?.[`${insightKey}`] && (
                                        <div>
                                          {!this.state[
                                            `${insightKey}-editable`
                                          ] && (
                                            <Button
                                              id={`${insightKey}-editable`}
                                              size="small"
                                              className=""
                                              kind="ghost"
                                              disabled={Object.keys(scoreDetail)
                                                ?.filter(
                                                  (k) => k !== insightKey
                                                )
                                                ?.some(
                                                  (k) =>
                                                    this.state[
                                                      `${k}-editable`
                                                    ] === true
                                                )}
                                              onClick={() =>
                                                this.handleEditAccess(
                                                  insightKey,
                                                  true
                                                )
                                              }>
                                              Edit
                                            </Button>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="bx--row mb-1">
                                    <div className="bx--col-lg-12 bx--col-md-12 bx--col-sm-12 bx--col-xs-12">
                                      <div className="f-w-b mb-2">
                                        Generated AI Insight
                                      </div>
                                      <span
                                        className="mb-0 d-inline-block"
                                        style={{
                                          fontSize: 14,
                                          textAlign: 'justify',
                                          lineHeight: '1.1rem',
                                        }}>
                                        {summary?.[`${insightKey}`] ?? '-NA-'}
                                      </span>
                                    </div>
                                  </div>
                                  {summary?.[`${insightKey}`] && (
                                    <>
                                      {this.state[`${insightKey}-editable`] ? (
                                        <div className="bx--row mb-1">
                                          <div className="bx--col-lg-12 bx--col-md-12 bx--col-sm-12 bx--col-xs-12">
                                            <div className="f-w-b mb-2 mt-3">
                                              Modified AI Insight
                                            </div>
                                            <TextArea
                                              name={`${insightKey}-modified`}
                                              id={`${insightKey}-modified`}
                                              value={
                                                modifiedSummary?.[
                                                  `${insightKey}`
                                                ]
                                              }
                                              onChange={(e) =>
                                                this.handleChange(
                                                  e,
                                                  'modifiedSummary',
                                                  insightKey
                                                )
                                              }
                                              labelText=""
                                              hideLabel
                                              placeholder="Please enter the text"
                                              rows={5}
                                            />

                                            {this.state[
                                              `${insightKey}-editable`
                                            ] && (
                                              <div className="d-flex mt-2">
                                                <div>
                                                  <Button
                                                    id={`${insightKey}-cancel`}
                                                    size="small"
                                                    className=""
                                                    kind="ghost"
                                                    onClick={() =>
                                                      this.handleEditAccess(
                                                        insightKey,
                                                        false
                                                      )
                                                    }>
                                                    Cancel
                                                  </Button>
                                                </div>
                                                <div>
                                                  <Button
                                                    id={`${insightKey}-save`}
                                                    size="small"
                                                    className="ml-3"
                                                    kind="primary"
                                                    onClick={() =>
                                                      this.handleSave(
                                                        insightKey
                                                      )
                                                    }>
                                                    Save
                                                  </Button>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="bx--row mb-1">
                                          <div className="bx--col-lg-12 bx--col-md-12 bx--col-sm-12 bx--col-xs-12">
                                            <span
                                              className="mb-0 d-inline-block"
                                              style={{
                                                fontSize: 14,
                                                textAlign: 'justify',
                                                lineHeight: '1.1rem',
                                              }}>
                                              <div className="f-w-b mt-3 mb-2">
                                                Modified AI Insight
                                              </div>
                                              {modifiedSummary?.[
                                                `${insightKey}`
                                              ] ?? '-NA-'}
                                            </span>
                                          </div>
                                        </div>
                                      )}
                                    </>
                                  )}
                                </div>
                                <hr className="mb-2 mt-2" />
                              </>
                            );
                          }
                        )}
                      </>
                    ) : (
                      <div className="h6 text-center">
                        {this.state.message || 'No data found'}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Tile>
        <JDProcessOverlay show={this.props.loading} message="processing..." />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.Assessments.loading,
  assessCandInfo: state.Assessments.assessCandInfo,
});

const mapDispatchToProps = {
  getAsessmentCandidateInfo,
  updateAsessmentCandidate,
  updateCandAssessLinkSatus,
  getJSCReportInsightsByCandId,
  updatetCandJSCReport,
  generateJSCReport,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssessCandidateInfo);
